import { __assign } from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { getBasicBiDataForDuperItem } from '../redux/helpers';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './BackToStreamButton.scss';
var BackToStreamButton = function (_a) {
    var className = _a.className, exitDuperbrowse = _a.exitDuperbrowse, parent = _a.parent, currentItem = _a.currentItem;
    var t = useTranslation().t;
    // Ads
    var adsEnabled = useContext(SessionContext).adsEnabled;
    var adsNitro = useFlag('ads_nitro');
    var showAd = adsEnabled && adsNitro;
    if (!parent || !currentItem) {
        return null;
    }
    return (React.createElement(TextButton, { icon: ArrowLeft, variant: "main", size: "small", biData: __assign(__assign({ evid: BiEventType.BACK_TO_CLICK }, getBasicBiDataForDuperItem(currentItem)), { link_url: parent.url, next_itemid: parent.itemId, next_typeid: parent.typeId }), className: classnames(s['duperexit'], showAd && s['with-ad'], className), onClick: exitDuperbrowse, noHorizontalPaddings: false }, parent.title || t('deviation.duperbrowse.back')));
};
BackToStreamButton.displayName = 'BackToStreamButton';
export default BackToStreamButton;
//# sourceMappingURL=BackToStreamButton.js.map